export enum SpeechContentType {
  Main = 'main',
  Voices = 'voices',
  Library = 'library',
}

export const TABS = ['text', 'speech'] as const
export type TabOption = (typeof TABS)[number]
